export const IconWrapper = ({
    children,
    size = 16,
  }: {
    children: React.ReactNode;
    size?: number;
  }) => (
    <svg
      width={size}
      height={size}
      viewBox="15 12 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-wrapper-flow"
    >
      {children}
    </svg>
  );